module.exports = "<button [disabled]=\"disabled\" class=\"btn {{cssClass}}\" (click)=\"onBtnClick($event)\">\r\n  <ng-content></ng-content>\r\n</button>\r\n"